import { useMemo, useState } from "react";
import { Flex, Text, Box, Divider, VStack } from "@chakra-ui/react";
import { FiStar } from "react-icons/fi";
import { applyPixMask, formatPixKey } from "@/utils";
import { Input } from "@/components";
export function PixKeySelector({ value, onChange, onSelect, error, pixFavorites }) {
  const [searchTerm, setSearchTerm] = useState(value || "");

  const handleChange = (e) => {
    const raw = e.target.value;
    // Se for QR Code (começa com "000201"), não aplica máscara
    const masked = raw.trim().startsWith("000201") ? raw : applyPixMask(raw);
    setSearchTerm(masked);
    onChange(masked);
  };

  const filteredFavorites = useMemo(() => {
    const term = searchTerm.toLowerCase().trim();
    if (!term) return pixFavorites;
    return pixFavorites.filter(
      (fav) =>
        fav.recipientName.toLowerCase().includes(term) ||
        fav.nickname?.toLowerCase().includes(term) ||
        fav.pixKey.toLowerCase().includes(term)
    );
  }, [searchTerm, pixFavorites]);

  return (
    <Flex 
        w="100%" 
        h="100%"
        gap="4"
        flexDir="column"
        justify="center"
    >
      <VStack align="flex-start" spacing={3}>
        <Text fontSize="22px" fontWeight="semibold">
          Para quem você quer transferir?
        </Text>
        <Text fontSize="12px">
          Digite a chave Pix, cole o código QR Code PIX ou selecione um contato da sua lista
        </Text>

        <Input
          placeholder="Nome, CPF/CNPJ, telefone, chave Pix ou código QR Code PIX"
          value={searchTerm}
          onChange={handleChange}
          borderColor={error ? "red.400" : "gray.200"}
          _focus={{ borderColor: error ? "red.400" : "black" }} 
          name={""}        />

        {error && (
          <Text fontSize="xs" color="red.500" mt={1}>
            {error}
          </Text>
        )}
      </VStack>

      <Box border="1px solid #DFDEDF" borderRadius="8px">
        <Flex align="center" gap="2" px={4} py={2}>
          <FiStar />
          <Text fontWeight="medium">Favoritos</Text>
        </Flex>
        <Divider />
        {filteredFavorites.length === 0 ? (
          <Box px={4} py={3}>
            <Text color="gray.500" fontSize="sm">
              Nenhum favorito encontrado
            </Text>
          </Box>
        ) : (
          filteredFavorites.map((fav) => (
            <Box
              key={fav.id}
              _hover={{ bg: "#F9F9F9", cursor: "pointer" }}
              px={4}
              py={2}
              onClick={() => onSelect(fav)}
            >
              <Flex align="center" justify="space-between">
                <VStack spacing={0} align="flex-start">
                    <Text fontWeight="medium">{fav.recipientName}</Text>
                    <Text fontSize="xs" color="gray.500">
                    {formatPixKey(fav.pixKey, fav.pixKeyType)}
                    </Text>
                </VStack>
                <Text fontSize="sm" fontWeight="medium">
                    {fav.pixKeyType}
                </Text>
            </Flex>

            </Box>
          ))
        )}
      </Box>
    </Flex>
  );
}
